/** A panel with its right-hand drawer marked — the chat history rail. */
const CloseDrawerRight = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.5"
        y="4.5"
        width="15"
        height="15"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M18.25 4.5C18.9404 4.5 19.5 5.05964 19.5 5.75V18.25C19.5 18.9404 18.9404 19.5 18.25 19.5H15V4.5H18.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default CloseDrawerRight;
